import { render, staticRenderFns } from "./park-v4ward-settings.vue?vue&type=template&id=b840d860&scoped=true&"
import script from "./park-v4ward-settings.vue?vue&type=script&lang=js&"
export * from "./park-v4ward-settings.vue?vue&type=script&lang=js&"
import style0 from "./park-v4ward-settings.vue?vue&type=style&index=0&id=b840d860&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b840d860",
  null
  
)

export default component.exports